<template>
  <div class="ui masthead vertical segment">
    <div class="ui container">
      <div class="introduction">
          <br />
          <span v-if="getOcupaAtras" style="display:inline-block;">
            <router-link :to="getUrlAtras">
              <h2 style=" font-size:21px;color:#1b396a;">
                <i class="arrow left icon"></i>
              </h2>
            </router-link>
          </span>
          <span style="display:inline-block;margin-left:10px;">
            <h1 style=" font-size: 26px;color: #5c5d5d; letter-spacing: 0.04rem;">
              {{ getTitulo }}
            </h1>
          </span>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		regresar: {
			type: Function,
			default: null
		}
	},
	computed: {
		...mapGetters('app', ['getTitulo', 'getUrlAtras', 'getOcupaAtras'])
	},
	methods: {}
	// 
};
</script>

<style lang="scss" module>
@import '@design';
</style>
